const SCROLL_MARGIN = 16;

async function getIonContentScrollElement(
  element: HTMLElement
): Promise<HTMLElement | null> {
  const ionContent = element.closest('ion-content');

  if (!(ionContent instanceof HTMLElement)) {
    return null;
  }

  const scrollElement = await (
    ionContent as HTMLIonContentElement & {
      getScrollElement?: () => Promise<HTMLElement>;
    }
  ).getScrollElement?.();

  return scrollElement ?? null;
}

function scrollElementBy(
  scrollElement: HTMLElement | null,
  delta: number,
  behavior: ScrollBehavior
) {
  if (scrollElement) {
    scrollElement.scrollBy({ top: delta, behavior });
    return;
  }

  window.scrollBy({ top: delta, behavior });
}

export async function scrollFocusedInputIntoView(
  options: { behavior?: ScrollBehavior } = {}
) {
  const active = document.activeElement;

  if (!(active instanceof HTMLElement)) {
    return;
  }

  const behavior = options.behavior ?? 'auto';
  const viewport = window.visualViewport;
  const scrollElement = await getIonContentScrollElement(active);
  const rect = active.getBoundingClientRect();

  if (!viewport) {
    active.scrollIntoView({ block: 'nearest', behavior });
    return;
  }

  const visibleTop = viewport.offsetTop + SCROLL_MARGIN;
  const visibleBottom = viewport.offsetTop + viewport.height - SCROLL_MARGIN;

  if (rect.top < visibleTop) {
    scrollElementBy(scrollElement, rect.top - visibleTop, behavior);
    return;
  }

  if (rect.bottom > visibleBottom) {
    scrollElementBy(scrollElement, rect.bottom - visibleBottom, behavior);
  }
}

export function scheduleScrollFocusedInputIntoView(
  options: { behavior?: ScrollBehavior } = {}
) {
  requestAnimationFrame(() => {
    void scrollFocusedInputIntoView(options);
  });
}
